// Financial Reporting suite — pure label helpers shared by the loan tab and
// the portfolio reporting page.

import type { ReportSeriesCadence } from "@/api/portfolioAdmin/financialReportingApi";

/** "June 2026" (monthly) / "Q2 2026" (quarterly) / "2026" (annual) —
 *  parsed from the period-end calendar date, never timezone-shifted. */
export function reportingPeriodLabel(
  cadence: ReportSeriesCadence,
  periodEnd: string,
): string {
  const [y, m] = periodEnd.slice(0, 10).split("-").map(Number);
  if (!y || !m) return "—";
  if (cadence === "Monthly") {
    return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString("en-US", {
      month: "long",
      year: "numeric",
      timeZone: "UTC",
    });
  }
  if (cadence === "Quarterly") return `Q${Math.ceil(m / 3)} ${y}`;
  return String(y);
}

/** Cadence-agnostic variant for contexts that only know the series code.
 *  Matches on the cadence letter after the discipline prefix ("FR-M4",
 *  "DW-M1" → Monthly) so non-FR series label correctly. */
export function periodLabelForCode(code: string, periodEnd: string): string {
  const cadenceLetter = code.split("-")[1]?.[0];
  const cadence: ReportSeriesCadence =
    cadenceLetter === "M" ? "Monthly" : cadenceLetter === "Q" ? "Quarterly" : "Annual";
  return reportingPeriodLabel(cadence, periodEnd);
}
